// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.5576 12.356L11.7151 7.51354L2.07153 17.1573L2.07153 21.9997L6.91397 21.9997L16.5576 12.356Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.7803 8.13243C22.1174 6.79523 22.1174 4.62721 20.7802 3.29001C19.443 1.9528 17.275 1.95281 15.9378 3.29002L14.1896 5.03826L12.904 3.75266L11.4898 5.16687L18.9034 12.5805L20.3176 11.1663L19.032 9.88069L20.7803 8.13243Z"}}]};

const SipFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sip-filled',
    ref,
    icon: element,
  },
));

SipFilledIcon.displayName = 'SipFilledIcon';

export default SipFilledIcon;
